import React from 'react';
import UserCard2 from 'components/Shared/UserCard2/UserCard2';
import Panel from 'components/Panel/Panel';
import userCardStyles from 'components/Shared/UserCard2/UserCard2.module.scss';

const CreativePitchUserCard = ({ pitch, user, preferredRole }) => {
  return (
    <Panel className={userCardStyles.gridContainer}>
      <UserCard2 user={user} pitch={pitch} preferredRole={preferredRole} />
    </Panel>
  );
};

export default CreativePitchUserCard;
